const getInitialState = () =>
  JSON.parse(document.getElementById('initialState').innerHTML)

export default getInitialState
